import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="min-h-screen bg-gradient-to-br from-yellow-50 to-amber-50 flex items-center justify-center px-4">
      <div class="max-w-2xl w-full">
        <div class="bg-white rounded-3xl shadow-2xl p-12 text-center border border-yellow-100">
          <!-- Animated 403 -->
          <div class="mb-8">
            <div class="relative inline-block">
              <h1 class="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 to-amber-600">
                403
              </h1>
              <div class="absolute inset-0 blur-2xl opacity-30 bg-gradient-to-r from-yellow-400 to-amber-500"></div>
            </div>
          </div>

          <!-- Icon -->
          <div class="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-yellow-50 to-amber-100 rounded-2xl flex items-center justify-center">
            <svg class="w-12 h-12 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
          </div>

          <!-- Message -->
          <h2 class="text-3xl font-bold text-gray-900 mb-4">Access Denied</h2>
          <p class="text-lg text-gray-600 mb-8 leading-relaxed">
            You don't have permission to access this page. This area is restricted to authorized users only.
          </p>

          <!-- Actions -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              (click)="goBack()"
              class="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transform hover:scale-105 transition-all duration-200 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Go Back
            </button>
            <button
              (click)="goHome()"
              class="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gradient-to-r from-yellow-600 to-amber-600 text-white rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
              </svg>
              Back to Home
            </button>
          </div>

          <!-- Login Option -->
          <div class="mt-10 pt-8 border-t border-gray-200">
            <p class="text-sm text-gray-600 mb-3">Need access to this page?</p>
            <a href="/login" class="inline-flex items-center gap-2 text-yellow-700 hover:text-yellow-800 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
              </svg>
              Sign In
            </a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class ForbiddenComponent {
  constructor(private router: Router, private location: Location) {}

  goBack(): void {
    this.location.back();
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
